import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import '../style/brand-section.css';
import { initializeBrandSection } from '../script/brand-section';
import brand1 from '../../../../../assets/logo/why_choose_us/1.webp';
import brand2 from '../../../../../assets/logo/why_choose_us/2.webp';
import brand3 from '../../../../../assets/logo/why_choose_us/3.webp';
import brand4 from '../../../../../assets/logo/why_choose_us/4.webp';

const BrandSection: React.FC = () => {
    const containerRef = useRef<HTMLElement>(null);

    useEffect(() => {
        if (!containerRef.current) {
            return;
        }

        // Wait for Swiper to be available and DOM to be ready
        const checkSwiper = () => {
            if (typeof (window as any).Swiper !== 'undefined') {
                initializeBrandSection(containerRef.current);
            } else {
                setTimeout(checkSwiper, 100);
            }
        };

        const timer = setTimeout(() => {
            checkSwiper();
        }, 500);

        return () => {
            clearTimeout(timer);
        };
    }, []);

    return (
        <section className="brand-one" style={{ backgroundColor: '#ffffff' }} ref={containerRef}>
            <div className="container">
                <div className="brand-one__inner">
                    <div className="swiper-container brand-one__carousel" style={{ backgroundColor: '#ffffff' }}>
                        <div className="swiper-wrapper">
                            {/* Start Brand One Single */}
                            <div className="swiper-slide">
                                <div className="brand-one__single">
                                    <div className="brand-one__single-inner" style={{ backgroundColor: '#ffffff' }}>
                                        <Link to="#">
                                            <img loading="lazy" src={brand1} alt="" style={{ width: '168px', height: '82px', objectFit: 'contain' }} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* End Brand One Single */}

                            {/* Start Brand One Single */}
                            <div className="swiper-slide">
                                <div className="brand-one__single">
                                    <div className="brand-one__single-inner" style={{ backgroundColor: '#ffffff' }}>
                                        <Link to="#">
                                            <img loading="lazy" src={brand2} alt="" style={{ width: '168px', height: '82px', objectFit: 'contain' }} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* End Brand One Single */}

                            {/* Start Brand One Single */}
                            <div className="swiper-slide">
                                <div className="brand-one__single">
                                    <div className="brand-one__single-inner" style={{ backgroundColor: '#ffffff' }}>
                                        <Link to="#">
                                            <img loading="lazy" src={brand3} alt="" style={{ width: '168px', height: '82px', objectFit: 'contain' }} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* End Brand One Single */}

                            {/* Start Brand One Single */}
                            <div className="swiper-slide">
                                <div className="brand-one__single">
                                    <div className="brand-one__single-inner" style={{ backgroundColor: '#ffffff' }}>
                                        <Link to="#">
                                            <img loading="lazy" src={brand4} alt="" style={{ width: '168px', height: '82px', objectFit: 'contain' }} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                            {/* End Brand One Single */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BrandSection;

